import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "./Login.css"; // Import CSS for styling
import { baseUrlUser } from "./common";
// import illustration from "../assests/Illustration.png";

const Login = (props) => {
  const [email, setEmail] = useState(""); // Use email state
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false); // Remember Me state
  const [errorMessage, setErrorMessage] = useState(""); // Corrected state for error messages
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate(); // Initialize navigate

  const handleLogin = async (e) => {
  e.preventDefault();
  setErrorMessage(""); 

  const allowedEmails = ['babita.n@trezi.com', 'arpan.p@trezi.com', 'sudarshan@smartvizx.com'];

  if (!allowedEmails.includes(email.toLowerCase())) {
    setErrorMessage("You are not authorized to log in.");
    return;
  }

  try {
    const response = await fetch(`${baseUrlUser}users/login/product`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Product: "LensLite",
      },
      credentials: "include",
      body: JSON.stringify({
        email: email.toLowerCase(),
        password: password,
      }),
    });

    if (!response.ok) {
      if (response.status === 400) {
        setErrorMessage("Invalid Login");
      } else if (response.status === 403) {
        setErrorMessage("User is currently inactive.");
      } else if (response.status === 404) {
        setErrorMessage("Sorry, we couldn't find an account with that email address.");
      } else {
        setErrorMessage("Please check login details again");
      }
      return;
    }

    const data = await response.json();
    const { treziAccessToken, orgIdentifier, role } = data;

    if (!treziAccessToken) {
      setErrorMessage("Invalid Login and Password");
      return;
    }

    localStorage.setItem("email", email);
    localStorage.setItem("treziAccessToken", treziAccessToken);
    localStorage.setItem("organizationIdentifier", orgIdentifier);
    localStorage.setItem("role", role);

    if (rememberMe) {
      localStorage.setItem("rememberMe", JSON.stringify({ email, password }));
    }
props.checkAuthentication();

navigate("/dashboard");
  } catch (error) {
    console.error("Error:", error);
    setErrorMessage("An error occurred during login.");
  }
};


  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };
  useEffect(() => {
    const video = document.getElementById("background-video");
    if (video) {
      video.playbackRate = 0.9; // Adjust speed (1 is normal speed, 0.7 slows it down)
    }
  }, []);
  return (
    <div className="login-page">
    
      <div className="login-container">
        <div className="login-image">
          {/* <img src={illustration} alt="Login Illustration" /> */}
        </div>
        <div className="login-form">
          <form onSubmit={handleLogin}>
            <div className="welcome">Welcome to Trezi</div>
            <div className="user mt-3">User Credentials</div>
            <input
            className="mt-2"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)} // Update email state
              style={{ width: '85%', marginTop: '15px' }} 
            />
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)} // Update password state
              style={{ width: '85%', marginTop: '15px' }} 
            />
          
            <div>
            <div className="remember-me">
              <input
                type="checkbox"
                id="rememberMe"
                checked={rememberMe}
                onChange={handleRememberMeChange}
              />
              <label htmlFor="rememberMe">Remember Me</label>
            </div>
              <button type="submit" className="submit-button">
                Sign in
              </button>
            </div>
            {errorMessage && <p className="error">{errorMessage}</p>} {/* Show error message */}
            {successMessage && <p className="success">{successMessage}</p>} {/* Show success message */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
